import { useRouter } from 'next/router';
import type { Schema } from 'zod';
import type { z } from 'zod';

export function useTypedRouter<ZodSchema extends Schema>(schema: ZodSchema) {
  const router = useRouter();
  const parsedQuery = schema.safeParse(router.query);

  if (parsedQuery.success) {
    return {
      ...router,
      query: parsedQuery.data as z.infer<typeof schema>,
    };
  }

  /* istanbul-ignore-next */
  if (process.env.NODE_ENV === 'development') {
    /* istanbul-ignore-next */
    throw parsedQuery.error;
  }

  // eslint-disable-next-line no-console
  console.error(parsedQuery.error);

  return {
    ...router,
    query: {} as Partial<z.infer<typeof schema>>,
  };
}
